<template>
  <div>
    <a-tag
      v-for="(tag,i) in boothList"
      :key="i"
      v-model="visible"
      :closable="!disabled"
      @close="closeTags(i)"
    >{{ tag.exnum }}</a-tag>
    <template v-if="!disabled && boothList.length < max">
      <a-input
        v-if="inputVisible"
        ref="input"
        v-model="inputValue"
        :style="{ width: '78px' }"
        type="text"
        size="small"
        :max-length="150"
        @blur="handleInputConfirm"
        @keyup.enter="handleInputConfirm"
      />
      <a-tag
        v-else
        style="background: #fff; borderStyle: dashed;cursor: pointer;padding:3px 6px;"
        @click="showInput"
      >
        <a-icon type="plus" /> {{ $t('constructionPermit.添加展位') }}
      </a-tag>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    boothList: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: Infinity
    }
  },
  data() {
    return {
      inputValue: '',
      inputVisible: false,
      exhibitionId: sessionStorage.getItem('exhibitionId'),
      visible: true
    }
  },
  methods: {
    showInput() {
      this.inputVisible = true
      this.$nextTick(function() {
        this.$refs.input.focus()
      })
    },
    closeTags(index) {
      this.boothList.splice(index, 1)
      this.$nextTick(() => {
        this.visible = true
        this.emit()
      })
    },
    handleInputConfirm() {
      if (this.inputValue) {
        this.$http.get(`${this.api}a/api/project/booth/?boothNo=${this.inputValue}&projectId=${this.exhibitionId}`).then(res => {
          if ((res.data.resultCode === 0 || res.data.resultCode === '0') && res.data.data && res.data.data.id) {
            const exnum = res.data.data.exnum
            const isBooth = this.boothList.some(booth => {
              return booth.exnum === exnum
            })
            if (!isBooth) {
              this.boothList.push(res.data.data)
            }
            // res.data.map(item => {
            //   const isBooth = this.boothList.find(booth => {
            //     return booth.exnum === item.exnum
            //   })
            //   if (!isBooth) {
            //     this.boothList.push(item)
            //   }
            // })
            this.emit()
          } else {
            this.$message.error(this.$t('constructionPermit.无此展位'))
          }
        })
      }
      this.inputValue = ''
      this.inputVisible = false
    },
    emit() {
      this.$emit('update:boothList', this.boothList)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/component/base/addBoothByTag.vue